<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      wrap
    >
      <v-flex
        xs12
        md4
      >
        <v-card
          class="merchant-card"
          justify-center
          text-center
        >
          <v-card-text>
            <v-flex>
              <center>
                <v-img
                  :src="fiftyx_logo"
                  :lazy-src="fiftyx_logo"
                  height="40"
                  contain
                />
                <h4>50x.com</h4>
                <span>{{ $t('merchants.exchange') }}</span>
    
                <p>
                  {{ $t('merchants.fiftyxDesc') }}
                </p>
              </center>
            </v-flex>
          </v-card-text>    
       
          <v-divider />      
          <v-card-actions
            justify-end
          >
            <v-spacer />
            <v-btn
              class="primary"
              @click="redirectToMerchant('fiftyx')"
            >
              {{ $t('toolbar.buyButton') }}
            </v-btn> 
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        md4
      >
        <v-card
          class="merchant-card"
          justify-center
          text-center
        >
          <v-card-text>
            <v-flex>
              <center>
                <v-img
                  :src="abcc_logo"
                  :lazy-src="abcc_logo"
                  height="40"
                  contain
                />
                <h4>ABCC</h4>
                <span>{{ $t('merchants.exchange') }}</span>
    
                <p>
                  {{ $t('merchants.abccDesc') }}
                </p>
              </center>
            </v-flex>
          </v-card-text>    
       
          <v-divider />      
          <v-card-actions
            justify-end
          >
            <v-spacer />
            <v-btn
              class="primary"
              @click="redirectToMerchant('abcc')"
            >
              {{ $t('toolbar.buyButton') }}
            </v-btn> 
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container> 
</template>

<script>

export default {
  name: 'Merchants',
  data() {
    return {
      abcc_logo: require('@/images/abcc.png'),
      fiftyx_logo: require('@/images/50x.png'),
      loading: false
    }
  },
  methods: {
    redirectToMerchant(id) {
      if (id == 'abcc')
        return window.open('https://abcc.com/en/pro/markets/aivusdt', '_blank')
      if (id == 'fiftyx')
        return window.open('https://trade.50x.com/webapp/en/terminal/AIV-USDT', '_blank')
    }
  },
}
</script>
<style lang="scss" scoped>
  .merchant-card {
    padding: 0;
    .v-image {
      margin: 5px 0 20px;
    }
    h4 {
      text-align: center;
      font-size: 22px!important;
      font-weight: 700!important;
      margin:0!important;
    }
    span {
      font-size: 11px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      margin-top:10px;
      max-width:250px;
    }
  }
</style>
